<template>
  <EventAllDay
    v-if="event"
    :event="event"
    :is-selected="isSelected"
    :is-single-event="isSingleEvent"
    @select="$emit('select', $event)"
    @unselect="$emit('unselect')"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import * as inject from "@/components/inject";
import { useReleaser } from "@/ref";

import EventAllDay from "./EventAllDay.vue";

export default defineComponent({
  name: "EventAllDayWrapper",
  components: {
    EventAllDay,
  },
  props: {
    eventId: {
      type: String,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isSingleEvent: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    select: (_id: string) => true,
    unselect: () => true,
  },
  async setup(props) {
    const controller = inject.controller();
    const releaser = useReleaser();
    const event = await releaser.add(controller.event.get(props.eventId));
    return {
      event,
    };
  },
});
</script>
